import { Component as ComponentContainer } from '@styles/layout';
import { DestinationGroupComponent, DestinationGroupTypes } from '@model/content';
import { DestinationList } from './DestinationList';
import { DestinationsGroup } from './DestinationsGroup';

export const DestinationsGroupContainer = (props: DestinationGroupComponent) => {
  const { type } = props;

  return (
    <ComponentContainer>
      {type === DestinationGroupTypes.STANDARD && <DestinationsGroup {...props} />}
      {type !== DestinationGroupTypes.STANDARD && (
        <DestinationList {...props} isResortList={type === DestinationGroupTypes.RESORT_LIST} />
      )}
    </ComponentContainer>
  );
};
